export default "__VITE_ASSET__DewXBH7Y__"